/* SOLER 2026 — interacciones sin dependencias */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const R = (window.SOLER && window.SOLER.routes) || { cart_add: '/cart/add', cart: '/cart', cart_change: '/cart/change', root: '/' };
  const push = (event, data = {}) => { try { (window.dataLayer = window.dataLayer || []).push({ event, ...data }); } catch (e) {} };

  /* ---------- Revelar al hacer scroll ---------- */
  const revealEls = $$('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else revealEls.forEach((el) => el.classList.add('is-in'));

  /* ---------- Paneles (menú móvil y carrito) ---------- */
  let lastFocus = null;
  const openPanel = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('button, a, input');
    f && setTimeout(() => f.focus(), 60);
  };
  const closePanel = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-mnav-open]')) { openPanel($('[data-mnav]')); $('[data-mnav-open]').setAttribute('aria-expanded', 'true'); }
    if (t.closest('[data-mnav-close]')) { closePanel($('[data-mnav]')); $('[data-mnav-open]') && $('[data-mnav-open]').setAttribute('aria-expanded', 'false'); }
    if (t.closest('[data-cart-close]')) closePanel($('[data-cart-drawer]'));
    if (t.closest('[data-cart-open]') && window.SOLER && window.SOLER.cartDrawer && !document.body.classList.contains('tpl-cart')) {
      e.preventDefault(); openPanel($('[data-cart-drawer]'));
    }
    const mnavLink = t.closest('.mnav a');
    if (mnavLink) closePanel($('[data-mnav]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      $$('.mnav.is-open, .drawer.is-open').forEach(closePanel);
      const menu = $('#wa-menu'); if (menu && !menu.hidden) toggleWa(false);
    }
  });

  /* ---------- Carrito AJAX ---------- */
  const refreshCart = async (open = false) => {
    try {
      const res = await fetch(`${R.root.replace(/\/$/, '')}/?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('[data-cart-drawer]');
      const current = $('[data-cart-drawer]');
      if (fresh && current) {
        const wasOpen = current.classList.contains('is-open') || open;
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) { current.classList.add('is-open'); current.setAttribute('aria-hidden', 'false'); }
      }
      const countSrc = html.querySelector('[data-cart-count-src]');
      const count = countSrc ? countSrc.textContent.trim() : '0';
      $$('[data-cart-count]').forEach((b) => { b.textContent = count; b.dataset.count = count; });
      if (open) openPanel($('[data-cart-drawer]'));
    } catch (err) { if (open) window.location.href = R.cart; }
  };

  const addToCart = async (form, goCheckout = false) => {
    const btn = form.querySelector('[data-add-btn]') || form.querySelector('[type="submit"]');
    btn && btn.classList.add('is-loading');
    try {
      const fd = new FormData(form);
      const res = await fetch(`${R.cart_add}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const item = await res.json();
      if (!res.ok) throw new Error(item.description || 'No se pudo agregar');
      push('add_to_cart_soler', { item_name: item.product_title, item_variant: item.variant_title, price: item.final_price / 100 });
      if (goCheckout) { window.location.href = '/checkout'; return; }
      if (window.SOLER && window.SOLER.cartDrawer) await refreshCart(true);
      else window.location.href = R.cart;
    } catch (err) {
      alert(err.message || 'No se pudo agregar al carrito. Intenta de nuevo.');
    } finally { btn && btn.classList.remove('is-loading'); }
  };

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-add-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-buy-now]');
    if (!b) return;
    const form = b.closest('form');
    form && addToCart(form, true);
  });

  /* Cambiar cantidades (drawer y página de carrito) */
  const changeLine = async (line, quantity) => {
    try {
      await fetch(`${R.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) }) });
      if (document.body.classList.contains('tpl-cart')) window.location.reload();
      else await refreshCart();
    } catch (e) { window.location.reload(); }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    const line = b.closest('[data-line]');
    line && changeLine(line.dataset.line, b.dataset.qtyChange);
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-qty-input]');
    if (!i) return;
    const line = i.closest('[data-line]');
    line && changeLine(line.dataset.line, i.value);
  });

  /* Stepper de cantidad en página de producto */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
  });

  /* ---------- Selector de variantes (tarjetas) ---------- */
  $$('[data-buy-form]').forEach((form) => {
    const radios = $$('input[type="radio"][name="id"]', form);
    if (!radios.length) return;
    const now = $('[data-price-now]', form), was = $('[data-price-was]', form), save = $('[data-price-save]', form);
    const wa = $('[data-wa-product]', form);
    const sticky = $('[data-sticky-price]');
    const isProductPage = !!form.closest('[data-product-page]');
    const update = (r) => {
      now.textContent = r.dataset.price;
      if (r.dataset.compare) { was.textContent = r.dataset.compare; was.hidden = false; } else was.hidden = true;
      if (Number(r.dataset.save) > 0) { save.textContent = `Ahorras ${r.dataset.save}%`; save.hidden = false; } else save.hidden = true;
      if (sticky && isProductPage) sticky.textContent = r.dataset.price;
      if (wa) {
        const msg = `${form.dataset.waBase} – ${r.dataset.title}`;
        const url = new URL(wa.href);
        url.searchParams.set('text', msg);
        wa.href = url.toString();
      }
      if (isProductPage && r.dataset.url && window.history.replaceState) {
        window.history.replaceState({}, '', r.dataset.url);
      }
    };
    radios.forEach((r) => r.addEventListener('change', () => update(r)));
  });

  /* ---------- Galería ---------- */
  $$('[data-gallery]').forEach((g) => {
    const main = $('[data-gallery-main] img', g);
    $$('[data-thumb]', g).forEach((t) => t.addEventListener('click', () => {
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = t.dataset.src;
      main.srcset = t.dataset.srcset;
      main.alt = t.dataset.alt;
      $$('[data-thumb]', g).forEach((x) => x.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
    }));
  });

  /* ---------- Barra de compra fija (móvil) ---------- */
  const sticky = $('[data-sticky-buy]');
  const anchor = $('[data-buy-form] .buybox');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
    }).observe(anchor);
  }

  /* ---------- Pestañas de sedes ---------- */
  $$('[data-tabs]').forEach((tabs) => {
    const section = tabs.closest('section');
    tabs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-tab]');
      if (!b) return;
      $$('[data-tab]', tabs).forEach((x) => x.setAttribute('aria-selected', String(x === b)));
      $$('[data-city]', section).forEach((c) => { c.hidden = b.dataset.tab !== 'all' && c.dataset.city !== b.dataset.tab; });
    });
  });

  /* ---------- WhatsApp flotante ---------- */
  const waBtn = $('[data-wa-toggle]');
  const waMenu = $('#wa-menu');
  function toggleWa(force) {
    if (!waBtn || !waMenu) return;
    const open = typeof force === 'boolean' ? force : waMenu.hidden;
    waMenu.hidden = !open;
    waBtn.setAttribute('aria-expanded', String(open));
  }
  waBtn && waBtn.addEventListener('click', () => toggleWa());
  document.addEventListener('click', (e) => {
    if (waMenu && !waMenu.hidden && !e.target.closest('[data-wa-float]')) toggleWa(false);
  });

  /* Medición de clics a WhatsApp (GTM) */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-wa-click]');
    if (a) push('whatsapp_click', { link_url: a.href, page_type: document.body.className });
  });

  /* ---------- Ordenar colección ---------- */
  const sort = $('[data-sort]');
  sort && sort.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
